/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ChangeNurseryStatusDto,
  CreateNurseryCommandControllerCreate201,
  CreateNurseryDto,
  ListNurseriesByOrganisationResponseDto,
  ListNurseriesQueryControllerListNurseriesParams,
  ListNurseriesResponseDto,
  NurseryPinReadinessResponseDto,
  NurseryResponseDto,
  TogglePinLoginDto,
  UpdateNurseryDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Lists active members with no PIN at all (neither own nor temporary). Intended as a pre-check before enabling PIN login for the nursery — listed users cannot log in on a shared device.
 * @summary Check whether a nursery's members are ready for PIN login
 */
export const getNurseryPinReadinessQueryControllerGetPinReadiness = (
  id: string,
  signal?: AbortSignal,
) => {
  return axiosClient<NurseryPinReadinessResponseDto>({
    url: `/v1/nurseries/${id}/pin-readiness`,
    method: "GET",
    signal,
  });
};

export const getGetNurseryPinReadinessQueryControllerGetPinReadinessQueryKey = (
  id: string,
) => {
  return [`/v1/nurseries/${id}/pin-readiness`] as const;
};

export const getGetNurseryPinReadinessQueryControllerGetPinReadinessQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getNurseryPinReadinessQueryControllerGetPinReadiness>
    >,
    TError = void,
  >(
    id: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getNurseryPinReadinessQueryControllerGetPinReadiness
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetNurseryPinReadinessQueryControllerGetPinReadinessQueryKey(id);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getNurseryPinReadinessQueryControllerGetPinReadiness>
      >
    > = ({ signal }) =>
      getNurseryPinReadinessQueryControllerGetPinReadiness(id, signal);

    return {
      queryKey,
      queryFn,
      enabled: id !== null && id !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getNurseryPinReadinessQueryControllerGetPinReadiness>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetNurseryPinReadinessQueryControllerGetPinReadinessQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getNurseryPinReadinessQueryControllerGetPinReadiness>
    >
  >;
export type GetNurseryPinReadinessQueryControllerGetPinReadinessQueryError =
  void;

export function useGetNurseryPinReadinessQueryControllerGetPinReadiness<
  TData = Awaited<
    ReturnType<typeof getNurseryPinReadinessQueryControllerGetPinReadiness>
  >,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNurseryPinReadinessQueryControllerGetPinReadiness
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getNurseryPinReadinessQueryControllerGetPinReadiness
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getNurseryPinReadinessQueryControllerGetPinReadiness
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNurseryPinReadinessQueryControllerGetPinReadiness<
  TData = Awaited<
    ReturnType<typeof getNurseryPinReadinessQueryControllerGetPinReadiness>
  >,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNurseryPinReadinessQueryControllerGetPinReadiness
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getNurseryPinReadinessQueryControllerGetPinReadiness
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getNurseryPinReadinessQueryControllerGetPinReadiness
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNurseryPinReadinessQueryControllerGetPinReadiness<
  TData = Awaited<
    ReturnType<typeof getNurseryPinReadinessQueryControllerGetPinReadiness>
  >,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNurseryPinReadinessQueryControllerGetPinReadiness
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Check whether a nursery's members are ready for PIN login
 */

export function useGetNurseryPinReadinessQueryControllerGetPinReadiness<
  TData = Awaited<
    ReturnType<typeof getNurseryPinReadinessQueryControllerGetPinReadiness>
  >,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNurseryPinReadinessQueryControllerGetPinReadiness
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetNurseryPinReadinessQueryControllerGetPinReadinessQueryOptions(
      id,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new nursery
 */
export const createNurseryCommandControllerCreate = (
  createNurseryDto: CreateNurseryDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateNurseryCommandControllerCreate201>({
    url: `/v1/nurseries`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createNurseryDto,
    signal,
  });
};

export const getCreateNurseryCommandControllerCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNurseryCommandControllerCreate>>,
    TError,
    { data: CreateNurseryDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNurseryCommandControllerCreate>>,
  TError,
  { data: CreateNurseryDto },
  TContext
> => {
  const mutationKey = ["createNurseryCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNurseryCommandControllerCreate>>,
    { data: CreateNurseryDto }
  > = (props) => {
    const { data } = props ?? {};

    return createNurseryCommandControllerCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNurseryCommandControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNurseryCommandControllerCreate>>
>;
export type CreateNurseryCommandControllerCreateMutationBody = CreateNurseryDto;
export type CreateNurseryCommandControllerCreateMutationError = unknown;

/**
 * @summary Create a new nursery
 */
export const useCreateNurseryCommandControllerCreate = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createNurseryCommandControllerCreate>>,
      TError,
      { data: CreateNurseryDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createNurseryCommandControllerCreate>>,
  TError,
  { data: CreateNurseryDto },
  TContext
> => {
  return useMutation(
    getCreateNurseryCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * Returns a paginated list of nurseries the user has access to. Supports filtering by organisation.
 * @summary List nurseries
 */
export const listNurseriesQueryControllerListNurseries = (
  params?: ListNurseriesQueryControllerListNurseriesParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ListNurseriesResponseDto>({
    url: `/v1/nurseries`,
    method: "GET",
    params,
    signal,
  });
};

export const getListNurseriesQueryControllerListNurseriesQueryKey = (
  params?: ListNurseriesQueryControllerListNurseriesParams,
) => {
  return [`/v1/nurseries`, ...(params ? [params] : [])] as const;
};

export const getListNurseriesQueryControllerListNurseriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
  TError = void,
>(
  params?: ListNurseriesQueryControllerListNurseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListNurseriesQueryControllerListNurseriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>
  > = ({ signal }) => listNurseriesQueryControllerListNurseries(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListNurseriesQueryControllerListNurseriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>
>;
export type ListNurseriesQueryControllerListNurseriesQueryError = void;

export function useListNurseriesQueryControllerListNurseries<
  TData = Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
  TError = void,
>(
  params: undefined | ListNurseriesQueryControllerListNurseriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
          TError,
          Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListNurseriesQueryControllerListNurseries<
  TData = Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
  TError = void,
>(
  params?: ListNurseriesQueryControllerListNurseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
          TError,
          Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListNurseriesQueryControllerListNurseries<
  TData = Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
  TError = void,
>(
  params?: ListNurseriesQueryControllerListNurseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List nurseries
 */

export function useListNurseriesQueryControllerListNurseries<
  TData = Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
  TError = void,
>(
  params?: ListNurseriesQueryControllerListNurseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listNurseriesQueryControllerListNurseries>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListNurseriesQueryControllerListNurseriesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a nursery
 */
export const updateNurseryCommandControllerUpdate = (
  id: string,
  updateNurseryDto: UpdateNurseryDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateNurseryDto,
    signal,
  });
};

export const getUpdateNurseryCommandControllerUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNurseryCommandControllerUpdate>>,
    TError,
    { id: string; data: UpdateNurseryDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNurseryCommandControllerUpdate>>,
  TError,
  { id: string; data: UpdateNurseryDto },
  TContext
> => {
  const mutationKey = ["updateNurseryCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNurseryCommandControllerUpdate>>,
    { id: string; data: UpdateNurseryDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateNurseryCommandControllerUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNurseryCommandControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNurseryCommandControllerUpdate>>
>;
export type UpdateNurseryCommandControllerUpdateMutationBody = UpdateNurseryDto;
export type UpdateNurseryCommandControllerUpdateMutationError = unknown;

/**
 * @summary Update a nursery
 */
export const useUpdateNurseryCommandControllerUpdate = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateNurseryCommandControllerUpdate>>,
      TError,
      { id: string; data: UpdateNurseryDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateNurseryCommandControllerUpdate>>,
  TError,
  { id: string; data: UpdateNurseryDto },
  TContext
> => {
  return useMutation(
    getUpdateNurseryCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Soft delete a nursery
 */
export const deleteNurseryCommandControllerDelete = (
  id: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${id}`,
    method: "DELETE",
    signal,
  });
};

export const getDeleteNurseryCommandControllerDeleteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNurseryCommandControllerDelete>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNurseryCommandControllerDelete>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteNurseryCommandControllerDelete"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNurseryCommandControllerDelete>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteNurseryCommandControllerDelete(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNurseryCommandControllerDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNurseryCommandControllerDelete>>
>;

export type DeleteNurseryCommandControllerDeleteMutationError = unknown;

/**
 * @summary Soft delete a nursery
 */
export const useDeleteNurseryCommandControllerDelete = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteNurseryCommandControllerDelete>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteNurseryCommandControllerDelete>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getDeleteNurseryCommandControllerDeleteMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Get a nursery by ID
 */
export const getNurseryQueryControllerGet = (
  id: string,
  signal?: AbortSignal,
) => {
  return axiosClient<NurseryResponseDto>({
    url: `/v1/nurseries/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetNurseryQueryControllerGetQueryKey = (id: string) => {
  return [`/v1/nurseries/${id}`] as const;
};

export const getGetNurseryQueryControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNurseryQueryControllerGetQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNurseryQueryControllerGet>>
  > = ({ signal }) => getNurseryQueryControllerGet(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNurseryQueryControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNurseryQueryControllerGet>>
>;
export type GetNurseryQueryControllerGetQueryError = void;

export function useGetNurseryQueryControllerGet<
  TData = Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getNurseryQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNurseryQueryControllerGet<
  TData = Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getNurseryQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNurseryQueryControllerGet<
  TData = Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a nursery by ID
 */

export function useGetNurseryQueryControllerGet<
  TData = Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNurseryQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetNurseryQueryControllerGetQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Enable or disable PIN login for a nursery
 */
export const togglePinLoginCommandControllerToggle = (
  id: string,
  togglePinLoginDto: TogglePinLoginDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${id}/pin-login`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: togglePinLoginDto,
    signal,
  });
};

export const getTogglePinLoginCommandControllerToggleMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof togglePinLoginCommandControllerToggle>>,
    TError,
    { id: string; data: TogglePinLoginDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof togglePinLoginCommandControllerToggle>>,
  TError,
  { id: string; data: TogglePinLoginDto },
  TContext
> => {
  const mutationKey = ["togglePinLoginCommandControllerToggle"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof togglePinLoginCommandControllerToggle>>,
    { id: string; data: TogglePinLoginDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return togglePinLoginCommandControllerToggle(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TogglePinLoginCommandControllerToggleMutationResult = NonNullable<
  Awaited<ReturnType<typeof togglePinLoginCommandControllerToggle>>
>;
export type TogglePinLoginCommandControllerToggleMutationBody =
  TogglePinLoginDto;
export type TogglePinLoginCommandControllerToggleMutationError = void;

/**
 * @summary Enable or disable PIN login for a nursery
 */
export const useTogglePinLoginCommandControllerToggle = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof togglePinLoginCommandControllerToggle>>,
      TError,
      { id: string; data: TogglePinLoginDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof togglePinLoginCommandControllerToggle>>,
  TError,
  { id: string; data: TogglePinLoginDto },
  TContext
> => {
  return useMutation(
    getTogglePinLoginCommandControllerToggleMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Change a nursery lifecycle status (platform admin only)
 */
export const changeNurseryStatusCommandControllerChangeStatus = (
  id: string,
  changeNurseryStatusDto: ChangeNurseryStatusDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${id}/status`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: changeNurseryStatusDto,
    signal,
  });
};

export const getChangeNurseryStatusCommandControllerChangeStatusMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof changeNurseryStatusCommandControllerChangeStatus>
      >,
      TError,
      { id: string; data: ChangeNurseryStatusDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof changeNurseryStatusCommandControllerChangeStatus>
    >,
    TError,
    { id: string; data: ChangeNurseryStatusDto },
    TContext
  > => {
    const mutationKey = ["changeNurseryStatusCommandControllerChangeStatus"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof changeNurseryStatusCommandControllerChangeStatus>
      >,
      { id: string; data: ChangeNurseryStatusDto }
    > = (props) => {
      const { id, data } = props ?? {};

      return changeNurseryStatusCommandControllerChangeStatus(id, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ChangeNurseryStatusCommandControllerChangeStatusMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof changeNurseryStatusCommandControllerChangeStatus>>
  >;
export type ChangeNurseryStatusCommandControllerChangeStatusMutationBody =
  ChangeNurseryStatusDto;
export type ChangeNurseryStatusCommandControllerChangeStatusMutationError =
  void;

/**
 * @summary Change a nursery lifecycle status (platform admin only)
 */
export const useChangeNurseryStatusCommandControllerChangeStatus = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof changeNurseryStatusCommandControllerChangeStatus>
      >,
      TError,
      { id: string; data: ChangeNurseryStatusDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changeNurseryStatusCommandControllerChangeStatus>>,
  TError,
  { id: string; data: ChangeNurseryStatusDto },
  TContext
> => {
  return useMutation(
    getChangeNurseryStatusCommandControllerChangeStatusMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List all nurseries for an organisation
 */
export const listNurseriesByOrganisationQueryControllerList = (
  organisationId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<ListNurseriesByOrganisationResponseDto>({
    url: `/v1/organisations/${organisationId}/nurseries`,
    method: "GET",
    signal,
  });
};

export const getListNurseriesByOrganisationQueryControllerListQueryKey = (
  organisationId: string,
) => {
  return [`/v1/organisations/${organisationId}/nurseries`] as const;
};

export const getListNurseriesByOrganisationQueryControllerListQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
  >,
  TError = void,
>(
  organisationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListNurseriesByOrganisationQueryControllerListQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNurseriesByOrganisationQueryControllerList>>
  > = ({ signal }) =>
    listNurseriesByOrganisationQueryControllerList(organisationId, signal);

  return {
    queryKey,
    queryFn,
    enabled: organisationId !== null && organisationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listNurseriesByOrganisationQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListNurseriesByOrganisationQueryControllerListQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listNurseriesByOrganisationQueryControllerList>>
  >;
export type ListNurseriesByOrganisationQueryControllerListQueryError = void;

export function useListNurseriesByOrganisationQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
  >,
  TError = void,
>(
  organisationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
          >,
          TError,
          Awaited<
            ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListNurseriesByOrganisationQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
  >,
  TError = void,
>(
  organisationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
          >,
          TError,
          Awaited<
            ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListNurseriesByOrganisationQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
  >,
  TError = void,
>(
  organisationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all nurseries for an organisation
 */

export function useListNurseriesByOrganisationQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
  >,
  TError = void,
>(
  organisationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNurseriesByOrganisationQueryControllerList>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListNurseriesByOrganisationQueryControllerListQueryOptions(
      organisationId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
